var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ElTooltip',{staticClass:"ui-icon-button",attrs:{"content":_vm.tooltip,"disabled":!_vm.tooltip,"placement":"top"}},[_c('ElButton',_vm._g(_vm._b({attrs:{"icon":_vm.icon,"type":_vm.type}},'ElButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }